import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { CopyIcon } from 'Asset/icon';
import { useToast } from 'Store/toast';
import { TextMedium } from 'UiKit/typography';

import styles from './styles.module.css';

const ColumnBarcode = ({ value }) => {
  const { t } = useTranslation('stock-promo');
  const { onOpenToast } = useToast();
  const handleCopy = () => {
    navigator.clipboard.writeText(value);
    onOpenToast({
      status: 'success',
      description: t("columnTableStockProduct.successCopyClipboard"),
      duration: 5,
      alwaysShow: false,
    });
  };
  return (
    <Box className={`${styles['column-barcode__container']} `}>
      <TextMedium className={styles['column-barcode__text']}>{value}</TextMedium>
      <CopyIcon size="16px" color="var(--color-primary60)" onClick={handleCopy} className={styles['column-barcode__icon']} data-testid="copy-icon" />
    </Box>
  );
};

export default ColumnBarcode;
